import { UseFormReturn } from 'react-hook-form';
import { SxProps } from '@cp/ds/src/theme';
import { CareerId } from '@common/const/catalog/career';
import { CareerDictionaryResponse } from '@cp/entities/career';

export enum FormAvailableOnlyFieldName {
  Date = 'date',
  Start = 'start',
  End = 'end',
  AvailableOnly = 'availableOnly',
}

export type FormAvailableOnlyModel = {
  [Key in FormAvailableOnlyFieldName.Date]: string | null;
} & {
  [Key in FormAvailableOnlyFieldName.Start]: string | null;
} & {
  [Key in FormAvailableOnlyFieldName.End]: string | null;
} & {
  [Key in FormAvailableOnlyFieldName.AvailableOnly]: boolean;
};

export type AvailableOnlyFieldProps<T extends Record<string, unknown>> = {
  careerId?: CareerId;
  form: UseFormReturn<FormAvailableOnlyModel & T>;
  sx?: SxProps;
  careerDictionary?: CareerDictionaryResponse | undefined;
  reducedWidth?: boolean;
};
